import { GET_TOKEN } from '../gql/auth';

export const clearUser = ({ client }) => {
  client.writeQuery({
    query: GET_TOKEN,
    data: {
      token: '',
      isLoggedIn: false,
      loading: false,
      netId: '',
      role: '',
    },
  });
};

export const loginUser = ({ client, login }) => {
  client.writeQuery({
    query: GET_TOKEN,
    data: {
      token: login.token,
      isLoggedIn: true,
      netId: login.me.netId,
      role: login.me.role,
      loginLoading: false,
    },
  });
};
